import { render, staticRenderFns } from "./roleGame copy.vue?vue&type=template&id=a07b98fa&scoped=true&"
import script from "./roleGame copy.vue?vue&type=script&lang=js&"
export * from "./roleGame copy.vue?vue&type=script&lang=js&"
import style0 from "./roleGame copy.vue?vue&type=style&index=0&id=a07b98fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a07b98fa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a07b98fa')) {
      api.createRecord('a07b98fa', component.options)
    } else {
      api.reload('a07b98fa', component.options)
    }
    module.hot.accept("./roleGame copy.vue?vue&type=template&id=a07b98fa&scoped=true&", function () {
      api.rerender('a07b98fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/auth/roles/components/roleGame copy.vue"
export default component.exports